import { MouseEvent } from "react";
import styles from "./AddPlacesFileItem.module.css";
import { downloadCSV, JSONArrayToCSV, PlacePropsList } from "../../../common/Common";
import Icon from "../../../common/Icon";
import { FileListItem } from "./AddMultiplePlaces";

interface AddPlacesFileItemProps {
    isActive: boolean;
    item: FileListItem;
    fieldName?: { [key: string]: string };
    failedData?: PlacePropsList;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    onClickDelete?: (e: MouseEvent<HTMLElement>) => void;
}

/**
 *
 * @author mjkang
 * @since 2024-10-02
 * @param props AddPlacesFileItemProps
 * @props isActive: 파일 선택 여부
 *        item: 파일 및 지오코딩 결과 데이터
 *        onClick: 파일 선택 시 onClick 함수
 *        onClickDelete?: 파일 삭제 버튼 클릭 시 onClick 함수
 * @returns AddPlacesFileItem
 */
const AddPlacesFileItem = (props: AddPlacesFileItemProps) => {
    const { file, result } = props.item;
    const isReady = props.onClickDelete !== undefined; // 지오코딩 처리 완료 여부

    /**
     * 실패 항목 다운로드 함수
     */
    const downloadFailedList = () => {
        const fileName = file.name.split(".")[0];
        const failedList = props.failedData;
        const fieldName = props.fieldName;

        if (fieldName && failedList) {
            const _data = Object.keys(failedList).map((key) => {
                return failedList[Number(key)];
            });

            const csv = JSONArrayToCSV([fieldName, ..._data]);
            downloadCSV(csv, `${fileName}_failed`);
        }
    };

    return (
        <div className={styles.wrapper} onClick={props.isActive ? undefined : props.onClick}>
            <div className={`${styles.file} ${props.isActive ? styles.active : ""}`}>
                <div className={styles.name}>
                    <Icon name={props.isActive ? "arrowUp" : "arrowDown"} color="darkGrey" />
                    <span className={`${styles.text} ${file.name.length > 30 && styles.long}`}>{file.name}</span>
                </div>
                {isReady && (
                    <div className={`${styles.button} ${props.isActive ? "" : styles.hidden}`} onClick={props.onClickDelete}>
                        <Icon name="del" color="darkGrey" />
                        <span className={styles.tooltip}>{"파일 삭제"}</span>
                    </div>
                )}
            </div>
            {isReady &&
                (result ? (
                    <div className={`${styles.result} ${props.isActive ? "" : styles.hidden}`}>
                        <div className={styles.row}>
                            <span>{"전체"}</span>
                            <span className={styles.all}>{result.success + result.fail}</span>
                        </div>
                        <div className={styles.row}>
                            <span>{"성공"}</span>
                            <span className={styles.success}>{result.success}</span>
                            <span>{"실패"}</span>
                            <span className={`${styles.fail} ${result.fail > 0 ? styles.download : ""}`} onClick={result.fail > 0 ? downloadFailedList : undefined}>
                                {result.fail}
                            </span>
                            {result.fail > 0 && <span className={styles.tooltip}>{"실패 항목 다운로드"}</span>}
                        </div>
                    </div>
                ) : (
                    <div className={`${styles.result} ${props.isActive ? "" : styles.hidden}`}>{"파일 등록에 실패하였습니다."}</div>
                ))}
        </div>
    );
};

export default AddPlacesFileItem;
